import { render, staticRenderFns } from "./MedicalStaffEdit.vue?vue&type=template&id=08003dee"
import script from "./MedicalStaffEdit.vue?vue&type=script&lang=js"
export * from "./MedicalStaffEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports